import apiService from './apiService';
import { Get_Token } from 'resolvers/Get_Token';

export const getUsers = async queryParams => {
    const params = {
        ...(queryParams?.search && { search: queryParams.search }),
        ...(queryParams?.page && { page: queryParams.page }),
        ...(queryParams?.limit && { limit: queryParams.limit }),
        ...(queryParams?.order && { order: queryParams.order })
    };
    const response = await apiService.get('/users', {
        headers: {
            Authorization: `Bearer ${Get_Token()}`
        },
        params
    });
    return response.data;
};

export const getProfileUser = async () => {
    const response = await apiService.get('/profile', {
        headers: {
            Authorization: `Bearer ${Get_Token()}`
        }
    });
    return response.data;
};

export const updatePasswordUser = async obj => {
    const newObject = {
        password: obj.oldPassword,
        newPassword: obj.newPassword
    };
    const response = await apiService.patch('/profile/changePassword', newObject, {
        headers: {
            Authorization: `Bearer ${Get_Token()}`
        }
    });
    return response.data;
};

export const submitPreKyc = async () => {
    const response = await apiService.post(
        '/users/meta/pre-kyc',
        {},
        {
            headers: {
                Authorization: `Bearer ${Get_Token()}`
            }
        }
    );

    return response.data;
};

export const submitPostApproveKyb = async () => {
    const response = await apiService.post(
        '/users/meta/post-kyb',
        {},
        {
            headers: {
                Authorization: `Bearer ${Get_Token()}`
            }
        }
    );

    return response.data;
};

export const createUser = async body => {
    const response = await apiService.post('/users', body, {
        headers: {
            Authorization: `Bearer ${Get_Token()}`
        }
    });

    return response.data;
};

export const updateUser = async (id, body) => {
    const response = await apiService.patch(`/users/${id}`, body, {
        headers: {
            Authorization: `Bearer ${Get_Token()}`
        }
    });

    return response.data;
};

export const deactivateUser = async id => {
    const response = await apiService.patch(
        `/users/${id}/deactivate`,
        {},
        {
            headers: {
                Authorization: `Bearer ${Get_Token()}`
            }
        }
    );

    return response.data;
};

export const getLastEULA = async id => {
    const response = await apiService.get(`/users/${id}/last-eula`, {
        headers: {
            Authorization: `Bearer ${Get_Token()}`
        }
    });

    return response.data;
};

export const updateLastEULA = async (id, lastAcceptedEula) => {
    const response = await apiService.patch(
        `/users/${id}/last-eula`,
        { lastAcceptedEula },
        {
            headers: {
                Authorization: `Bearer ${Get_Token()}`
            }
        }
    );

    return response.data;
};
